module.exports = __webpack_public_path__ + "static/media/loading.3dd2e6f3.gif";